@if (isActiveCall) {
    <span ngbTooltip="Aktiven klic" class="m-menu__link-badge">
        <span class="m-badge m-badge--danger mf-blink"></span>
    </span>
}
